export const categories = [
  { id: 'star-scandal', name: '明星黑料', slug: 'star-scandal', description: '最新明星黑料、塌房现场、娱乐圈猛料实时更新', icon: 'ri-star-line' },
  { id: 'influencer-gossip', name: '网红吃瓜', slug: 'influencer-gossip', description: '网红大瓜、主播爆料、社交媒体热议话题追踪', icon: 'ri-user-smile-line' },
  { id: 'blogger-flip', name: '博主翻车', slug: 'blogger-flip', description: '知名博主翻车现场、反差视频、争议事件全记录', icon: 'ri-alert-line' },
];

export const articles = [
  {
    id: 'article-1',
    title: '某顶流男星深夜酒店密会神秘女子，实锤视频曝光引发全网震动',
    slug: 'top-star-hotel-secret-date',
    excerpt: '近日有爆料称某当红顶流男星深夜现身某五星级酒店，与一名神秘女子举止亲密。爆料者提供了多段高清视频证据，画面中两人互动自然，疑似交往已久。此事迅速登上各大社交平台热搜榜首。',
    category: 'star-scandal',
    categoryName: '明星黑料',
    author: '前线瓜友小陈',
    date: '2026-07-06',
    readTime: '8分钟',
    viewCount: 1258000,
    commentCount: 36200,
    tags: ['顶流男星', '酒店密会', '实锤视频', '塌房现场'],
    heroImage: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20luxury%20hotel%20corridor%20at%20night%20with%20dramatic%20moody%20lighting%2C%20soft%20bokeh%20effects%2C%20mysterious%20atmosphere%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20paparazzi%20style%20photography%2C%20high%20contrast%2C%20editorial%20aesthetic%2C%20cinematic%20composition&width=1920&height=1080&seq=article-hero-01&orientation=landscape',
    thumbnail: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20entrance%20at%20night%20with%20dramatic%20lighting%2C%20mysterious%20silhouette%20walking%20through%20doors%2C%20cinematic%20paparazzi%20style%2C%20warm%20golden%20tones%2C%20soft%20bokeh%20background%2C%20editorial%20photography%2C%20simple%20composition%2C%20dark%20moody%20atmosphere&width=800&height=600&seq=article-thumb-01&orientation=landscape',
    content: [
      { type: 'paragraph', text: '娱乐圈的瓜永远不会让吃瓜群众失望。昨日深夜，知名娱乐博主"前线侦探"在其社交平台发布了一组令人震惊的高清视频，直指某当红顶流男星与一名神秘女子在五星级酒店亲密同行的画面。' },
      { type: 'paragraph', text: '据爆料者描述，该男星于7月5日晚间约22:30分左右，搭乘一辆黑色保姆车抵达北京某知名五星级酒店地下停车场。从车辆驶入到该男星下车，全程被多角度拍摄。画面中可见该男星头戴黑色棒球帽、黑色口罩，身着休闲便装，显然是为了低调出行。' },
      { type: 'paragraph', text: '随后，一名身穿白色连衣裙、长发披肩的年轻女子从同一车辆的另一侧下车。两人在停车场内并肩而行，期间该男星多次侧身与该女子交谈，神态自然亲密。电梯间监控画面更是拍到了两人在等待电梯时有肢体接触的瞬间。' },
      { type: 'paragraph', text: '这一爆料迅速在社交平台引发热议。话题#顶流男星酒店密会#在短短两小时内登顶微博热搜榜第一名，阅读量突破5亿次。大量网友涌入相关话题评论区，纷纷猜测该男星的身份以及神秘女子的背景。' },
      { type: 'paragraph', text: '截至目前，该男星所属经纪公司尚未对此事做出任何公开回应。其工作室的最新动态仍停留在三天前发布的品牌代言宣传内容上。这种沉默态度更是让粉丝和吃瓜群众感到不安。' },
      { type: 'paragraph', text: '值得注意的是，这已经不是该男星第一次陷入绯闻漩涡。去年九月，他就曾被拍到与某女演员深夜同返公寓，当时经纪公司以"普通朋友聚会"为由回应，但粉丝圈内早已流传两人正在交往的消息。' },
      { type: 'paragraph', text: '有业内人士分析认为，如果此次爆料属实，对该男星的商业价值将造成巨大冲击。据了解，该男星目前手上有超过十个品牌代言合同，其中多个品牌对代言人形象有严格的"单身人设"要求。一旦"塌房"，面临的违约金将是一个天文数字。' },
      { type: 'paragraph', text: '吃瓜群众们纷纷表示："这才是我们要的大瓜！""前线侦探永远的神！""坐等工作室道歉声明。"也有理智网友呼吁："吃瓜要理性，等官方回应再做判断。"' },
    ],
  },
  {
    id: 'article-2',
    title: '百万粉丝网红直播间翻车，假货被当场拆穿引发退网风波',
    slug: 'influencer-fake-goods-live-fail',
    excerpt: '拥有超过300万粉丝的美妆网红在最新一场直播中，被消费者当场指出所售产品为假货。现场质检对比让直播间气氛瞬间跌至冰点，该网红随后匆忙下播，引发舆论风暴。',
    category: 'influencer-gossip',
    categoryName: '网红吃瓜',
    author: '吃瓜前线观察员',
    date: '2026-07-05',
    readTime: '6分钟',
    viewCount: 983000,
    commentCount: 28500,
    tags: ['网红翻车', '直播带货', '假货', '退网'],
    heroImage: 'https://readdy.ai/api/search-image?query=Dramatic%20live%20streaming%20studio%20with%20ring%20light%20and%20beauty%20products%20on%20display%2C%20chaotic%20atmosphere%20with%20scattered%20cosmetics%2C%20warm%20lighting%20contrasting%20with%20dark%20shadows%2C%20documentary%20style%20photography%2C%20cinematic%20composition%2C%20moody%20atmosphere&width=1920&height=1080&seq=article-hero-02&orientation=landscape',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beauty%20live%20streaming%20setup%20with%20ring%20light%20and%20cosmetics%20products%20on%20desk%2C%20warm%20pink%20and%20gold%20tones%2C%20soft%20lighting%2C%20editorial%20product%20photography%2C%20clean%20simple%20background%2C%20minimal%20composition&width=800&height=600&seq=article-thumb-02&orientation=landscape',
    content: [
      { type: 'paragraph', text: '直播带货翻车年年有，今年特别多。7月4日晚间，坐拥320万粉丝的美妆带货主播"糖糖好物推荐"在直播中遭遇了职业生涯最大的一次危机。一位购买了其推荐产品的消费者在直播间公屏上连续刷屏，声称自己收到的产品与直播间展示的样品完全不同。' },
      { type: 'paragraph', text: '起初，主播糖糖试图忽视这些弹幕，继续按照脚本推进直播。但随着质疑声越来越多，越来越多的观众开始在弹幕中要求主播当场进行产品比对。在舆论压力下，糖糖不得不临时暂停直播流程，拿出自己的样品与消费者提供的照片进行对比。' },
      { type: 'paragraph', text: '对比结果令人震惊。正品包装上的防伪标识、字体印刷的细节、产品质地的差异，每一项都在指向一个事实——消费者拿到的产品与直播间展示的正品存在明显差异。现场气氛瞬间凝固，弹幕开始疯狂刷屏："假货实锤！""退钱！""报警！"' },
      { type: 'paragraph', text: '面对铁证，主播糖糖的表情从镇定变为慌乱，最终以"信号不好"为由匆忙关闭了直播。这一举动彻底点燃了消费者的怒火，相关话题在半小时内冲上热搜，阅读量突破2亿。' },
      { type: 'paragraph', text: '这并不是糖糖第一次陷入争议。早在上个月，就有不少消费者在评价区反映其推荐的产品"与直播间看到的完全不一样""用了之后过敏严重"。但这些声音都被其庞大的粉丝基数所淹没。' },
      { type: 'paragraph', text: '事件发酵后，已有超过5000名消费者自发组建维权群，准备联合向市场监管部门投诉。有律师表示，如果查实存在售假行为，该主播将面临刑事和民事双重责任。而其背后的MCN机构也可能被追究连带责任。' },
      { type: 'paragraph', text: '糖糖的个人社交账号评论区已全面沦陷。最新一条动态下方已有超过20万条评论，其中绝大多数是要求退款和道歉的声音。其账号粉丝数也在持续下降，截至发稿时已流失近50万粉丝。' },
    ],
  },
  {
    id: 'article-3',
    title: '知名美食博主被曝视频造假，摆拍浪费食材引发行业反思',
    slug: 'food-blogger-fake-video-scandal',
    excerpt: '坐拥500万粉丝的美食博主被前员工实锤爆料视频造假。爆料者称博主为追求视觉效果，大量浪费食材且多次摆拍，与视频中"家常便饭"的人设严重不符。',
    category: 'blogger-flip',
    categoryName: '博主翻车',
    author: '真相调查员阿瓜',
    date: '2026-07-04',
    readTime: '7分钟',
    viewCount: 756000,
    commentCount: 19200,
    tags: ['美食博主', '视频造假', '浪费食材', '人设崩塌'],
    heroImage: 'https://readdy.ai/api/search-image?query=Professional%20food%20photography%20kitchen%20setup%20with%20multiple%20dishes%20and%20camera%20equipment%2C%20behind%20the%20scenes%20aesthetic%2C%20warm%20culinary%20lighting%2C%20messy%20creative%20workspace%2C%20documentary%20style%2C%20cinematic%20composition&width=1920&height=1080&seq=article-hero-03&orientation=landscape',
    thumbnail: 'https://readdy.ai/api/search-image?query=Food%20photography%20kitchen%20table%20with%20beautifully%20plated%20dishes%20and%20camera%20setup%2C%20warm%20natural%20lighting%2C%20editorial%20food%20photography%2C%20clean%20simple%20composition%2C%20wooden%20table%20surface&width=800&height=600&seq=article-thumb-03&orientation=landscape',
    content: [
      { type: 'paragraph', text: '美食圈的造假风波来得猝不及防。7月3日，一位自称是知名美食博主"厨神小杰"前团队成员的匿名人士，在社交平台发布了一篇长达5000字的爆料长文，揭露了这位拥有500万粉丝的美食博主背后不为人知的造假内幕。' },
      { type: 'paragraph', text: '爆料者称，小杰视频中那些看似"随手一做就是满汉全席"的精致菜品，实际上是由一个五人团队花费数小时反复拍摄的成果。一个看似简单的炒菜镜头，背后至少准备了七八份相同的食材进行多次拍摄，只为捕捉最完美的火焰和蒸汽效果。' },
      { type: 'paragraph', text: '"他视频里说的‘今天随便做个家常菜’，实际上我们从早上八点就开始准备，一直拍到晚上十点。"爆料者写道，"而且每次拍摄结束后，那些为了追求视觉效果而被反复制作的菜品，大部分都被直接倒掉了。我们粗略计算，每次拍摄浪费的食材价值至少在一千元以上。"' },
      { type: 'paragraph', text: '更让粉丝感到愤怒的是，小杰在视频中反复强调自己"接地气""不浪费食材"的草根人设，与爆料者描述的实际情况形成了强烈反差。有粉丝统计，小杰在过去一年中至少有15个视频涉及"节约粮食"的主题内容。' },
      { type: 'paragraph', text: '消息一出，舆论迅速发酵。许多曾经与小杰合作过的品牌方纷纷发布声明，表示将暂停与他的所有合作。某知名厨具品牌的市场总监在接受采访时表示："我们选择小杰正是因为他的‘真实’形象，如果这些都是假的，那我们的合作基础就不存在了。"' },
      { type: 'paragraph', text: '小杰本人截至目前仍未对此事做出公开回应。其工作室仅在事件爆发后发布了一条简短的声明，称"正在调查相关情况，请广大粉丝理性看待"。但这一模糊的表态并未平息舆论风波。' },
      { type: 'paragraph', text: '这起事件也引发了整个美食短视频行业对创作底线的反思。多位业内人士指出，短视频平台"唯流量论"的评价体系，是导致创作者不惜造假追求视觉冲击的根本原因。这场风波或许将推动行业规则的重新制定。' },
    ],
  },
  {
    id: 'article-4',
    title: '某女星与前经纪公司解约内幕曝光，天价违约金背后的资本博弈',
    slug: 'actress-contract-termination-inside-story',
    excerpt: '一线女星与前经纪公司的解约纠纷持续升级。内部人士爆料称，解约背后涉及多方资本的激烈博弈，天价违约金的数字令人瞠目结舌，而这一切的导火索竟是一档综艺节目的档期安排。',
    category: 'star-scandal',
    categoryName: '明星黑料',
    author: '娱乐圈内参君',
    date: '2026-07-03',
    readTime: '9分钟',
    viewCount: 1823000,
    commentCount: 45600,
    tags: ['女星解约', '天价违约金', '资本博弈', '经纪公司'],
    heroImage: 'https://readdy.ai/api/search-image?query=Dramatic%20courtroom%20or%20negotiation%20room%20with%20empty%20chairs%20and%20documents%20on%20table%2C%20moody%20cinematic%20lighting%2C%20dark%20shadows%20with%20spotlight%20effect%2C%20high%20contrast%2C%20editorial%20photography%20style%2C%20tense%20atmosphere&width=1920&height=1080&seq=article-hero-04&orientation=landscape',
    thumbnail: 'https://readdy.ai/api/search-image?query=Elegant%20contract%20and%20pen%20on%20dark%20wooden%20desk%20with%20dramatic%20lighting%2C%20legal%20documents%20aesthetic%2C%20warm%20golden%20spotlight%2C%20editorial%20photography%2C%20clean%20minimal%20composition&width=800&height=600&seq=article-thumb-04&orientation=landscape',
    content: [
      { type: 'paragraph', text: '娱乐圈的资本博弈从来都不简单。近日，一线女星林某（化名）与前经纪公司星耀传媒的解约纠纷成为圈内最热门的话题。表面看是艺人与公司之间的普通合约纠纷，但深入调查后会发现，这场解约的背后是一场涉及多方资本的激烈博弈。' },
      { type: 'paragraph', text: '据知情人士透露，林某与星耀传媒的矛盾早在半年前就已显现。当时某头部视频平台推出一档投资过亿的大型综艺节目，点名要求林某担任常驻嘉宾。然而星耀传媒认为该节目的档期安排会与林某已有的影视剧拍摄计划冲突，拒绝了这一邀约。' },
      { type: 'paragraph', text: '这一决定让林某本人极为不满。据了解，该综艺节目给出的片酬高达8000万元，远超林某当时接拍的电视剧片酬。更重要的是，林某认为参加这种头部综艺对于提升自己的国民度和商业价值至关重要。' },
      { type: 'paragraph', text: '在此之后，另一家资本雄厚的经纪公司开始接触林某，并承诺可以帮助她完成解约并支付违约金。这家公司背后站着某互联网巨头，拥有强大的资源整合能力。面对这样的诱惑，林某最终决定单方面提出解约。' },
      { type: 'paragraph', text: '星耀传媒自然不会善罢甘休。根据合约条款，林某的单方面解约将触发高达1.2亿元的天价违约金。此外，星耀传媒还要求林某赔偿因解约造成的各项商业损失，包括正在洽谈的多个品牌代言合作。' },
      { type: 'paragraph', text: '目前，双方已经进入法律程序。有法律界人士分析认为，这场官司的核心争议点在于合约中关于档期安排的表决权归属问题。如果法院认定经纪公司滥用表决权损害艺人利益，违约金金额可能会有大幅调整。' },
      { type: 'paragraph', text: '无论最终结果如何，这场解约风波都已经对林某的公众形象造成了一定影响。部分网友认为她"过河拆桥"，也有人表示理解她追求更好发展的选择。而对于整个娱乐圈来说，这起案件可能成为一个重要的行业判例。' },
    ],
  },
  {
    id: 'article-5',
    title: '短视频平台知名情侣博主分手互撕，私密聊天记录流出引爆全网',
    slug: 'couple-blogger-breakup-drama',
    excerpt: '曾以"甜蜜情侣"人设走红的情侣博主突然宣布分手，随后双方在社交平台展开激烈互撕。大量私密聊天记录被曝光，其中涉及出轨、金钱纠纷等劲爆内容，令粉丝们大跌眼镜。',
    category: 'blogger-flip',
    categoryName: '博主翻车',
    author: '八卦小能手阿强',
    date: '2026-07-02',
    readTime: '10分钟',
    viewCount: 2345000,
    commentCount: 67800,
    tags: ['情侣博主', '分手互撕', '聊天记录', '出轨'],
    heroImage: 'https://readdy.ai/api/search-image?query=Shattered%20phone%20screen%20displaying%20social%20media%20chat%20interface%20with%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%2C%20broken%20heart%20symbolism%2C%20cinematic%20composition%2C%20high%20contrast%2C%20editorial%20style&width=1920&height=1080&seq=article-hero-05&orientation=landscape',
    thumbnail: 'https://readdy.ai/api/search-image?query=Two%20smartphones%20facing%20away%20from%20each%20other%20on%20dark%20surface%2C%20dramatic%20split%20lighting%2C%20relationship%20breakup%20concept%2C%20editorial%20photography%2C%20clean%20minimal%20composition&width=800&height=600&seq=article-thumb-05&orientation=landscape',
    content: [
      { type: 'paragraph', text: '互联网上最甜蜜的爱情，往往经不起现实的一击。7月1日晚间，拥有600万粉丝的知名情侣博主"小宇&甜甜"突然在各自的社交账号上同时发布分手声明，宣告这段持续三年的恋情画上句号。但谁都没想到，这仅仅是一场风暴的开始。' },
      { type: 'paragraph', text: '分手声明发布仅两小时后，女方甜甜再次发文，内容与之前的"和平分手"基调截然不同。在这条长文中，甜甜直指男方小宇在恋爱期间多次出轨，并列出了多个具体的时间点和对象。"我以为找到了真爱，没想到三年的感情全是谎言。"甜甜在文中这样写道。' },
      { type: 'paragraph', text: '面对指控，小宇迅速做出回应，否认了出轨一说，并反过来指控甜甜在恋爱期间存在严重的控制欲和金钱纠纷。“她把我当提款机，三年来我为她花的钱至少有200万，现在分手了还想让我继续给钱。”小宇的回应同样火药味十足。' },
      { type: 'paragraph', text: '随后，双方开始在社交平台上互相晒出私密聊天记录作为"证据"。甜甜晒出的截图显示小宇曾与多名女性暧昧聊天；而小宇晒出的截图则显示甜甜多次以"不给我买就分手"为由索要昂贵礼物。这些涉及隐私的内容迅速在全网传播，相关话题的阅读量在一夜之间突破10亿。' },
      { type: 'paragraph', text: '这场互撕大战让曾经喜爱他们的粉丝感到痛心和愤怒。许多粉丝在评论区留言："原来那些甜蜜视频都是演的""感觉被欺骗了三年的感情"。两人的粉丝数也在持续下降，合共掉粉超过200万。' },
      { type: 'paragraph', text: '有媒体评论指出，这起事件折射出网红情侣经济背后的深层问题。当感情与商业利益深度绑定，人设的经营往往优先于真实的情感维系。对于观众而言，这也是一堂关于"不要过度代入网红生活"的提醒课。' },
    ],
  },
  {
    id: 'article-6',
    title: '头部电商主播偷税漏税案新进展，补缴金额及罚款超5亿元',
    slug: 'top-livestreamer-tax-evasion-case',
    excerpt: '税务部门公布最新调查结果，某头部电商主播涉嫌通过多种手段偷逃个人所得税。根据通报，该主播已被要求补缴税款、滞纳金及罚款共计超过5亿元人民币，创下直播行业新纪录。',
    category: 'influencer-gossip',
    categoryName: '网红吃瓜',
    author: '财经观察员老张',
    date: '2026-07-01',
    readTime: '7分钟',
    viewCount: 3120000,
    commentCount: 89200,
    tags: ['电商主播', '偷税漏税', '天价罚款', '税务稽查'],
    heroImage: 'https://readdy.ai/api/search-image?query=Tax%20documents%20and%20calculator%20on%20dark%20desk%20with%20dramatic%20spotlight%2C%20financial%20investigation%20concept%2C%20moody%20cinematic%20lighting%2C%20high%20contrast%20shadows%2C%20editorial%20photography%2C%20serious%20atmosphere&width=1920&height=1080&seq=article-hero-06&orientation=landscape',
    thumbnail: 'https://readdy.ai/api/search-image?query=Financial%20documents%20spread%20on%20wooden%20desk%20with%20dramatic%20lighting%2C%20tax%20calculation%20concept%2C%20warm%20golden%20tones%2C%20editorial%20photography%2C%20clean%20minimal%20composition&width=800&height=600&seq=article-thumb-06&orientation=landscape',
    content: [
      { type: 'paragraph', text: '直播带货行业的税务风暴仍在持续。国家税务总局今日公布了某头部电商主播偷逃税款案的最新调查结果。根据通报，该主播在2020年至2025年期间，通过隐匿个人收入、虚构业务转换收入性质等方式，少缴个人所得税及附加税费。' },
      { type: 'paragraph', text: '税务部门通过大数据分析发现，该主播的实际收入与其申报纳税金额存在巨大差异。调查人员经过长达半年时间的深入核查，最终锁定了该主播通过多个空壳公司和个人账户分散收入以规避高额个税的事实。' },
      { type: 'paragraph', text: '根据最终核定，该主播被要求补缴税款2.8亿元，加收滞纳金1.5亿元，并处罚款0.8亿元，合计超过5亿元人民币。这一数字创下了中国直播行业税务处罚的新纪录，也在全网引发了巨大震动。' },
      { type: 'paragraph', text: '值得注意的是，该主播曾在2024年公开表示"自己一直按时足额纳税"，并在多个场合以"诚信纳税好公民"的形象示人。如今案件曝光，其人设彻底崩塌。该主播的所有社交账号已被平台封禁，多个品牌代言已被紧急撤下。' },
      { type: 'paragraph', text: '行业分析师指出，此案的查处对整个直播带货行业具有强烈的警示作用。此前已有多个头部主播因税务问题被查处，但此次案件涉及的金额之大、处罚之重，显示出监管部门的决心和力度正在持续升级。' },
      { type: 'paragraph', text: '多家直播平台也在事件后紧急发布公告，表示将加强对平台主播的税务合规管理，建立更加完善的收入申报和纳税监督机制。可以预见，直播带货行业将迎来更加规范的发展阶段。' },
    ],
  },
];

export const navLinks = [
  { name: '首页', href: '/', icon: 'ri-home-line' },
  { name: '明星黑料', href: '/category/star-scandal', icon: 'ri-star-line' },
  { name: '网红吃瓜', href: '/category/influencer-gossip', icon: 'ri-user-smile-line' },
  { name: '博主翻车', href: '/category/blogger-flip', icon: 'ri-alert-line' },
];

export const statsData = [
  { value: '10万+', label: '独家爆料', description: '累计收录真实爆料内容' },
  { value: '5000万+', label: '月度访问', description: '全网吃瓜用户月活跃量' },
  { value: '99%', label: '真实率', description: '经审核确认的爆料比例' },
  { value: '50+', label: '合作媒体', description: '深度合作的主流媒体平台' },
];

export const footerLinks = [
  {
    title: '快速导航',
    links: [
      { name: '首页', href: '/' },
      { name: '明星黑料', href: '/category/star-scandal' },
      { name: '网红吃瓜', href: '/category/influencer-gossip' },
      { name: '博主翻车', href: '/category/blogger-flip' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌介绍', href: '/about' },
      { name: '主编寄语', href: '/about' },
      { name: '联系方式', href: '/about' },
      { name: '加入我们', href: '/about' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { name: 'APP下载', href: '#download' },
      { name: '爆料投稿', href: '/about' },
      { name: '广告合作', href: '/about' },
      { name: '常见问题', href: '/about' },
    ],
  },
  {
    title: '友情链接',
    links: [
      { name: '吃瓜社区', href: '#' },
      { name: '八卦论坛', href: '#' },
      { name: '明星动态', href: '#' },
      { name: '影视追踪', href: '#' },
    ],
  },
];